(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["video-slider"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initBasicVideoSlider(sectionEl) {
      if (!sectionEl) return;
      const swiperEl = sectionEl.querySelector('.basic-swiper');
      if (!swiperEl) return;

      // Config uit data-attributen
      const perViewMobile = Number(sectionEl.dataset.mobile) || 1;
      const perViewTablet = Number(sectionEl.dataset.tablet) || 2;
      const perViewDesktop = Number(sectionEl.dataset.desktop) || 3;
      const spaceBetween = Number(sectionEl.dataset.space) || 12;

      function ensureSwiper(cb) {
        if (window.Swiper) return cb();
        const s = document.createElement('script');
        s.src = 'https://cdn.jsdelivr.net/npm/swiper@10/swiper-bundle.min.js';
        s.onload = cb;
        s.onerror = () => console.error('[Basic Slider] Swiper JS CDN failed to load');
        document.head.appendChild(s);
      }

      function loadVideo(videoEl) {
        if (!videoEl || videoEl.src) return;
        const src = videoEl.getAttribute('data-video-src');
        if (src) {
          videoEl.src = src;
          videoEl.load();
          videoEl.play().catch(() => {});
        }
      }

      function getActiveSlidesPerView(swiper) {
        const windowWidth = window.innerWidth;
        if (windowWidth >= 1024) return perViewDesktop;
        if (windowWidth >= 768) return perViewTablet;
        return perViewMobile;
      }

      ensureSwiper(() => {
        // Dubbele init voorkomen
        if (swiperEl.__basicSwiper) {
          swiperEl.__basicSwiper.destroy(true, true);
          swiperEl.__basicSwiper = null;
        }

        const navNext = sectionEl.querySelector('.swiper-button-next') || null;
        const navPrev = sectionEl.querySelector('.swiper-button-prev') || null;

        const config = {
          slidesPerView: perViewMobile,
          spaceBetween: spaceBetween,
          breakpoints: {
            768: { slidesPerView: perViewTablet },
            1024: { slidesPerView: perViewDesktop }
          },
          on: {
            init: function(swiper) {
              // Laad initiële zichtbare video's + 1 extra
              const currentPerView = getActiveSlidesPerView(swiper);
              const videosToLoad = Math.ceil(currentPerView) + 1;
              
              for (let i = 0; i < videosToLoad && i < swiper.slides.length; i++) {
                const video = swiper.slides[i].querySelector('video[data-video-src]');
                if (video) loadVideo(video);
              }
            },
            slideChange: function(swiper) {
              // Laad huidige zichtbare video's + 1 volgende
              const currentIndex = swiper.activeIndex;
              const currentPerView = getActiveSlidesPerView(swiper);
              const videosToLoad = Math.ceil(currentPerView) + 1;
              
              for (let i = 0; i < videosToLoad; i++) {
                const slideIndex = currentIndex + i;
                if (slideIndex < swiper.slides.length) {
                  const video = swiper.slides[slideIndex].querySelector('video[data-video-src]');
                  if (video) loadVideo(video);
                }
              }
            }
          }
        };

        // Alleen navigation opnemen als pijlen bestaan (show_arrows = true)
        if (navNext && navPrev) {
          config.navigation = { nextEl: navNext, prevEl: navPrev };
        }

        const swiper = new Swiper(swiperEl, config);
        swiperEl.__basicSwiper = swiper;
      });
    }

    // Vind de juiste sectie voor dit script
    function getSectionElFromScript(scriptEl) {
      let el = scriptEl.closest('[data-section-id]');
      if (el) return el;
      const all = document.querySelectorAll('.basic-video-slider[data-section-id]');
      return all[all.length - 1] || null;
    }

    function initFromScript(scriptEl) {
      const sectionEl = getSectionElFromScript(scriptEl);
      if (!sectionEl) return;
      initBasicVideoSlider(sectionEl);
    }

    // Init bij load
    if (document.currentScript) {
      initFromScript(document.currentScript);
    } else {
      document.addEventListener('DOMContentLoaded', () => {
        document.querySelectorAll('.basic-video-slider[data-section-id]').forEach(initBasicVideoSlider);
      });
    }

    // Re-init bij Theme Editor
    document.addEventListener('shopify:section:load', (e) => {
      const root = e.target?.querySelector?.('.basic-video-slider[data-section-id]') || e.target;
      if (root?.matches?.('.basic-video-slider[data-section-id]')) initBasicVideoSlider(root);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
